<template>
  <img class="logo-mini-icon" v-if="mini" src="@/assets/svg/unicall-logo-sign.svg" alt="Logo">
  <img v-else src="@/assets/svg/unicall-logo.svg" alt="Logo mini">
</template>

<script>
export default {
  props: {
    mini: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
</style>